<template>
    <form :id="id" @submit.prevent="handleSubmit" class="form-horizontal">
        <fieldset :disabled="disabled">

            <x-form-group :error="getError('guardians')">
                <x-table :headers="[
                    '',
                    'Akun',
                    'Relasi',
                ]">
                    <tr v-for="(guardian, index) in guardians" :key="index">
                        <x-delete-item-button @click="deleteGuardian(index)" />
                        <td>
                            <x-form-group :error="getError(`guardians.${index}.guardian_id`)">
                                <x-ajax-dropdown url="/api/users"
                                    :customLabel="(option) => `${option.name} (${option.email})`"
                                    v-model="guardian.guardian"
                                    class="form-control"
                                    :blacklist="selectedGuardianIds"
                                    :query="{ with: 'member_account' }" />
                                <x-help-default v-if="hasMemberAccount(guardian.guardian)">
                                    Terdaftar sebagai jemaat
                                </x-help-default>
                            </x-form-group>
                        </td>
                        <td>
                            <x-form-group :error="getError(`guardians.${index}.relation`)">
                                <input type="text"
                                    class="form-control"
                                    v-model="guardian.relation"
                                    placeholder="Relasi" />
                            </x-form-group>
                        </td>
                    </tr>

                    <template #footer="{ colspan }">
                        <tr>
                            <td :colspan="colspan" class="text-center">
                                <x-add-item-button @click="addGuardian" />
                            </td>
                        </tr>
                    </template>
                </x-table>
            </x-form-group>

        </fieldset>
    </form>
</template>

<script>
import XAddItemButton from '../../components/XAddItemButton.vue'
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XDeleteItemButton from '../../components/XDeleteItemButton.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XHelpDefault from '../../components/XHelpDefault.vue'
import XTable from '../../components/XTable.vue'
import FormErrorMixin from '../../mixins/FormErrorMixin'
export default {
    components: { XFormGroup, XTable, XAjaxDropdown, XAddItemButton, XDeleteItemButton, XHelpDefault, XTable },
    computed: {
        selectedGuardianIds() {
            return this.guardians.map(guardian => guardian.guardian?.id)
        }
    },
    created() {
        this.guardians = [ ...this.value ]
    },
    data() {
        return {
            guardians: [],
        }
    },
    methods: {
        addGuardian() {
            this.$set(this, 'guardians', [
                ...this.guardians,
                {
                    guardian_id: null,
                    guardian: null,
                    relation: null,
                }
            ])
        },
        deleteGuardian(target) {
            this.$set(this, 'guardians', [
                ...this.guardians.filter((member, index) => index != target)
            ])
        },
        hasMemberAccount(guardian) {
            if (!Boolean(guardian)) {
                return false
            }
            return Boolean(guardian.member_account)
        }
    },
    mixins: [
        FormErrorMixin,
    ],
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        errors: {
            type: Object,
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: null,
        },
        value: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    watch: {
        guardians: {
            handler(guardians) {
                this.$emit('input', [ ...guardians.map(guardian => ({
                    ...guardian,
                    guardian_id: guardian.guardian?.id
                })) ])
            },
            deep: true,
        },
    },
}
</script>